export default __webpack_public_path__ + "static/Dolomite-logo-f230ea5a91e8c1d31c7aaf89c19261a1.png";